import { render } from "./AddActivityDialog.vue?vue&type=template&id=af2fe37a&scoped=true&ts=true"
import script from "./AddActivityDialog.vue?vue&type=script&lang=ts"
export * from "./AddActivityDialog.vue?vue&type=script&lang=ts"

import "./AddActivityDialog.vue?vue&type=style&index=0&id=af2fe37a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af2fe37a"]])

export default __exports__